import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Config from "@app/dev/config/main";
import Timer from "@common/components/timer";
import { useTranslation } from "@common/hooks/translation";
import { RESET_UI_BY_IDLE_TIMER } from "@app/dev/actions/actionTypes";
import PaymentsService, { SessionBalanceStates } from "@app/dev/services/payments";
import { getAuthData } from "@common/helpers/auth";
import { useBalance } from "../../hooks/balance";
import { isMultiDepositModeEnabled } from '@app/dev/helpers/multiDepositMode';

export const InactiveTerminal = ({ closePopup }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const balance = useBalance();

  const onReset = useCallback(async () => {
    closePopup();
    const authData = getAuthData();
    if (!authData) return alert('there are no authdata')

    if (isMultiDepositModeEnabled()) {
      if (balance < 5) PaymentsService.clearSessionBalanceState();
      else {
        const emptyPlayerInfo = PaymentsService.getSessionBalanceEmptyState()

        await PaymentsService.setSessionBalanceState({
          ...emptyPlayerInfo,
          SessionBalanceState: SessionBalanceStates.Cash,
          CashdeskId: +authData.tid,
        });
      }
    }

    dispatch({ type: RESET_UI_BY_IDLE_TIMER });
  }, [balance, closePopup, dispatch]);

  useEffect(() => {
    document.addEventListener("click", closePopup);
    return () => document.removeEventListener("click", closePopup);
  }, [onReset, closePopup]);

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t("Terminal is inactive and will be reloaded.")}</h3>
      <div className="popup-main-content">
        <p className="text-center">{t("To activate the terminal touch the screen.")}</p>
        <Timer onFinish={onReset} duration={10 || Config.main.inactivePopupDuration} />
      </div>
    </div>
  );
};
